import { Button, Alert } from '@tunasong/ui-lib'
import { graphHooks } from '@tunasong/graph-lib/react'
import { Play } from '@tunasong/icons'
import { capitalize } from '@tunasong/models'
import { useCommandSpecRunner } from '@tunasong/plugin-lib'
import type { EntityEvent, EventCommands } from '@tunasong/schemas'
import type { SidebarComponent } from '@tunasong/ui-lib'
import { Divider, Link, useEventCommands, useProfileCommands } from '@tunasong/ui-lib'
import type { FC } from 'react'
import { EventCommandsList } from '../commands/event-commands-list.js'
import styles from './sidebar-events.module.css'
interface SidebarEventsProps extends SidebarComponent {}

export const SidebarEvents: FC<SidebarEventsProps> = props => {
  const { entity } = props
  const update = graphHooks.useEntityUpdate()

  // this will include the event commands defined in the profile
  const allEventCommands = useEventCommands(entity)
  const runner = useCommandSpecRunner()

  const { eventCommands = {} } = entity
  const { eventCommands: profileEventCommands } = useProfileCommands(entity.type)
  const handleUpdate = (eventCommands: EventCommands) => {
    update(entity.id, {
      eventCommands,
    })
  }
  const handleRun = (eventType: EntityEvent) => () => {
    if (!runner) {
      return
    }
    const commands = allEventCommands[eventType] ?? []
    for (const command of commands) {
      void runner({ spec: command, targetEntityId: entity.id })
    }
  }

  return (
    <>
      <EventCommandsList eventCommands={eventCommands} onChange={handleUpdate} />
      <Divider>Run for all {capitalize(entity.type ?? '')}s</Divider>
      <Alert severity="info">
        Configured in your <Link href={'/app/profile?tab=events'}>profile</Link>
      </Alert>
      <EventCommandsList eventCommands={profileEventCommands} />
      <Divider className={styles.divider} />
      {Object.keys(allEventCommands).map(eventType => (
        <Button
          key={`run-${eventType}`}
          disabled={!runner || (allEventCommands[eventType as EntityEvent] ?? []).length === 0}
          onClick={handleRun(eventType as EntityEvent)}
          startIcon={<Play />}
        >
          Run {eventType}
        </Button>
      ))}
      ,
    </>
  )
}
